/**
 * BookingStatusBadge — renders the true confirmation status of a booking.
 * Use EVERYWHERE a roster row shows whether a worker has confirmed, so nothing
 * reads "Confirmed" until the talent personally confirmed. Pairs with
 * AssignmentBadge (which shows Primary/Backup).
 *
 *   <BookingStatusBadge booking={rosterRow} />
 */
import React from 'react';
import { CheckCircle2, Clock, XCircle, ShieldCheck, UserX } from 'lucide-react';
import { getBookingStatus, BOOKING_STATUS } from '../utils/bookingStatus';

const ICON = {
  [BOOKING_STATUS.confirmed.label]: CheckCircle2,
  [BOOKING_STATUS.backupConfirmed.label]: CheckCircle2,
  [BOOKING_STATUS.adminOverride.label]: ShieldCheck,
  [BOOKING_STATUS.legacyUnverified.label]: Clock,
  [BOOKING_STATUS.reconfirmRequired.label]: Clock,
  [BOOKING_STATUS.awaiting.label]: Clock,
  [BOOKING_STATUS.backupAwaiting.label]: Clock,
  [BOOKING_STATUS.declined.label]: XCircle,
  [BOOKING_STATUS.released.label]: XCircle,
  [BOOKING_STATUS.canceled.label]: XCircle,
  [BOOKING_STATUS.noShow.label]: UserX,
};

export default function BookingStatusBadge({ booking, size = 'sm', className = '', testid }) {
  const s = getBookingStatus(booking || {});
  const I = ICON[s.label] || Clock;
  const sizeCls = size === 'md' ? 'text-xs px-2 py-0.5' : 'text-[10px] px-1.5 py-0.5';
  return (
    <span
      className={`inline-flex items-center gap-1 font-semibold uppercase tracking-wide border rounded ${s.cls} ${sizeCls} ${className}`}
      data-testid={testid || (booking?.booking_id ? `booking-status-${booking.booking_id}` : 'booking-status')}
      title={s.label}
    >
      <I className="w-3 h-3" /> {s.label}
    </span>
  );
}

export { BookingStatusBadge };
